// @ts-nocheck
import React from "react";
import { clarifyOptions } from "../utils/clarify";

/**
 * The intent finder's question as buttons (ACOP-147). Router-free, so it is unit-testable.
 *
 * AVS OS also streams the question as text, which the chat already shows as the assistant's message, so
 * when it sent `options` this renders just the buttons — repeating the sentence above them was the
 * duplicate. An AVS OS that predates `options` sent bare segment names and no usable text, so that
 * legacy shape keeps its own question line.
 */
export default function ClarifyPrompt({ clarifyData, onPick }) {
  const options = clarifyOptions(clarifyData);
  if (options.length === 0) return null;
  const hasOptions = Array.isArray(clarifyData?.options) && clarifyData.options.length > 0;
  return (
    <div className="c2-clarify" data-testid="c2-clarify">
      {!hasOptions && (
        <p className="c2-clarify-q">
          {clarifyData.clarifyingQuestion || "Which area does your question relate to?"}
        </p>
      )}
      <div className="c2-clarify-opts">
        {options.map((option, i) => (
          <button
            key={option.value}
            type="button"
            className="c2-clarify-btn"
            onClick={() => onPick(option)}
            data-testid="c2-clarify-option"
          >
            {hasOptions ? `${i + 1}. ${option.label}` : option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
